var map = {
	"./blank.png": 82174,
	"./blue.png": 54509,
	"./blue_pixel.png": 6026,
	"./blue_sands.png": 5674,
	"./blue_space.png": 18993,
	"./blue_splatter.png": 92215,
	"./daytime_scene.png": 32361,
	"./green.png": 41275,
	"./green_pixel.png": 17906,
	"./green_sands.png": 87091,
	"./green_space.png": 64871,
	"./green_splatter.png": 64008,
	"./nighttime_scene.png": 46813,
	"./orange_pixel.png": 56338,
	"./orange_sands.png": 6710,
	"./orange_space.png": 3710,
	"./orange_splatter.png": 99334,
	"./purple.png": 8810,
	"./purple_pixel.png": 2764,
	"./purple_sands.png": 65322,
	"./purple_space.png": 12705,
	"./purple_splatter.png": 26789,
	"./red.png": 71208,
	"./red_pixel.png": 81245,
	"./red_sands.png": 78568,
	"./red_space.png": 72447,
	"./red_splatter.png": 74829,
	"./solid_blue.png": 42266,
	"./solid_green.png": 83020,
	"./solid_orange.png": 97053,
	"./solid_purple.png": 57043,
	"./solid_red.png": 66002,
	"./solid_teal.png": 19161,
	"./solid_yellow.png": 1515,
	"./teal.png": 75419,
	"./teal_pixel.png": 112,
	"./teal_sands.png": 34062,
	"./teal_space.png": 38347,
	"./teal_splatter.png": 9109,
	"./turquoise_space.png": 67121,
	"./yellow.png": 7632,
	"./yellow_pixel.png": 30002,
	"./yellow_sands.png": 7307,
	"./yellow_space.png": 81577,
	"./yellow_splatter.png": 32504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21505;